<button *ngIf="energyEfficiencyClass"
     class="product-energy-efficiency"
        type="button"
        [attr.aria-label]="('CATALOG.DETAILS_PAGE.EEC.HEADER' | translate) + ' ' + energyEfficiencyClass"
     (click)="onEnergyEfficiencyLabelClick($event)">
  <div class="product-energy-efficiency__label__container">
    <img
      loading="lazy"
      class="product-energy-efficiency__label__image"
      [src]="energyLabelSrc"
      [alt]="('CATALOG.DETAILS_PAGE.EEC.HEADER' | translate) + ' ' + energyEfficiencyClass"
      onerror="this.setAttribute('data-broken', true)"/>
    <span class="product-energy-efficiency__label__text" *ngIf="isGenericLabel">{{energyEfficiencyClass}}</span>
  </div>
</button>
